export default function sacSutComplaint() {

  function verifyUnitSubject() {
    let unit = $('#sac select._unit').val();
    let subject = $('#sac select._subject').val();
    let sutComplaints = $('.sutComplaints');

    if (subject == '3' || subject == '2') {
      sutComplaints.show();
    } else {
      sutComplaints.hide();

      $('#sac input._product').val('');
      $('#sac input._anexos').val('');
    }
  }

  $('#sac select._unit, #sac select._subject').change(function (e) {
    e.preventDefault();
    verifyUnitSubject();
  })

  verifyUnitSubject();
}